export default "__VITE_ASSET__DPWbVjQ3__"